function noopAnalytics() {}

window.dataLayer = window.dataLayer || []
window.gtag = window.gtag || function gtag() {
  window.dataLayer.push(arguments)
}
window.fbq = window.fbq || noopAnalytics
